
import ImageViewer from "@/components/ImageViewer.vue";
import { BaseApiUrl } from "@/globals";
import { mapGetters } from "vuex";
import CardContratoHistorico from "@/components/venda/visualizar/CardContratoHistorico.vue";
import CardContratoDados from "@/components/venda/visualizar/CardContratoDados.vue";
import CardContratoAssociados from "@/components/venda/visualizar/CardContratoAssociados.vue";
import CardContratoContato from "@/components/venda/visualizar/CardContratoContato.vue";
import CardContratoEndereco from "@/components/venda/visualizar/CardContratoEndereco.vue";
import CardContratoContratante from "@/components/venda/visualizar/CardContratoContratante.vue";
import CardContratoRejeitado from "@/components/venda/visualizar/CardContratoRejeitado.vue";

export default {
  name: "home",
  data: () => ({
    loadingData: true,
    progress: 0,
    isEditing: false,
    dialogRejeitar: false,
    dialogAprovar: false,
    motivoRejeitado: "",
    snackbar: false,
    contrato: {
      contrato: {},
      rejeitada: {},
    },
    historico: [],
    headersHistorico: [
      { text: "Data", value: "data", align: "center", width: 50 },
      { text: "Hora", value: "hora", align: "center", width: 50 },
      { text: "Status", value: "status", align: "center" },
      { text: "Usuário", value: "nome_usuario", align: "start" },
      { text: "Obs", value: "obs", align: "center" },
    ],
    documentos: [],
    associadoHeader: [
      { text: "Nome", value: "nome" },
      { text: "CPF", value: "cpf" },
      { text: "Parentesco", value: "parentesco" },
      { text: "Nascimento", value: "nascimento" },
    ],
    tabelaContrato: [],
    headersContrato: [
      { text: "", value: "key" },
      { text: "", value: "value" },
    ],
    rejeitada: {},
    dialogDocumento: false,
    imageControls: {
      zoom: false,
    },
    documentoVisualizar: "",
    obs: "",
    load: false,
    imgRotation: 0,
  }),

  components: {
    ImageViewer,
    CardContratoHistorico,
    CardContratoDados,
    CardContratoAssociados,
    CardContratoContato,
    CardContratoEndereco,
    CardContratoContratante,
    CardContratoRejeitado,
  },

  computed: {
    BaseApiUrl() {
      return BaseApiUrl;
    },
    ...mapGetters("usuario", { usuario: "getUsuario" }),

    mode() {
      return this.$route.query.modo;
    },

    podeAnalisar() {
      if (this.mode != "analise") return false;
      if (this.contrato.contrato.status == "aprovada") return false;
      if (this.contrato.contrato.status == "rejeitado") return false;
      if (this.contrato.contrato.status == "cancelado") return false;
      if (this.contrato.contrato.status == "aguardando cancelamento")
        return false;
      else return true;
    },
  },

  methods: {
    setImageView(doc) {
      this.dialogDocumento = true;
      this.documentoVisualizar = doc;
    },
    rotateLeft() {
      this.imgRotation < 270
        ? (this.imgRotation = this.imgRotation + 90)
        : (this.imgRotation = 0);
    },
    rotateRight() {
      this.imgRotation > 270
        ? (this.imgRotation = this.imgRotation - 90)
        : (this.imgRotation = 0);
    },

    aprovar() {
      this.$http
        .put(`/venda/status/${this.$route.params.id}`, {
          userID: this.usuario.id,
          status: "aprovada",
          userName: this.usuario.nome,
        })
        .then(() =>
          this.$router.push({
            path: "/analise",
          })
        )
        .catch(() => (this.snackbar = true));
    },

    rejeitar() {
      this.$http
        .put(`/venda/status/${this.$route.params.id}`, {
          obs: this.motivoRejeitado,
          status: "rejeitado",
          userID: this.usuario.id,
          userName: this.usuario.nome,
        })
        .then(() =>
          this.$router.push({
            path: "/analise",
          })
        )
        .catch(() => (this.snackbar = true));
    },

    getHistorico() {
      this.$http
        .get(`/relatorio/historico/${this.$route.params.id}`)
        .then((res) => {
          this.historico = res.data;
        });
    },

    getDocumentos() {
      this.$http(`/venda/documento/${this.$route.params.id}`).then((res) => {
        this.documentos = res.data;
      });
    },

    editarVenda() {
      this.load = true;
      this.$router.push({
        path: `/analise/editar/${this.contrato.contrato.id}`,
      });
    },

    setPlanoName(id) {
      let plano = this.listaDePlanos.filter((plano) => plano.id == id);
      if (plano[0]) return plano[0].plano;
    },

    getContrato() {
      // Em homenagem ao meu querido amigo Júnior,
      // os dados de contrato sao acessado dentro de contrato.contrato
      // ;)
      this.$http
        .get(`/venda/${this.$route.params.id}`)
        .then((res) => {
          this.contrato = res.data;
          this.tabelaContrato = res.data.tabela;
          this.loadingData = false;
          if (
            this.mode == "analise" &&
            res.data.contrato.status === "aguardando análise"
          ) {
            this.setStatus();
          }
        })
        .catch((err) => alert(err));
    },

    setStatus() {
      this.$http
        .put(`/venda/status/${this.$route.params.id}`, {
          status: "em análise",
          userID: this.usuario.id,
          userName: this.usuario.nome,
        })
        .then(() => (this.contrato.contrato.status = "em análise"));
    },
  },

  filters: {
    dataFormatada: function (value) {
      if (value) {
        let d = value.split("-");
        let dia = d[2].split("T")[0];
        let mes = d[1];
        let ano = d[0];

        return `${dia}/${mes}/${ano}`;
      } else {
        return "erro na data";
      }
    },
    horaFormatada: function (value) {
      if (value) {
        let hora = value.split("T")[1].split(".")[0];
        return hora;
      }
    },
    upper(value) {
      return String(value).toUpperCase();
    },
    dinheiro(value) {
      let dinheiro = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return dinheiro.format(value);
    },
  },

  mounted() {
    this.getContrato();
    this.getHistorico();
    this.getDocumentos();
  },
};
